import { showNotification } from 'helpers';
import { Modal } from '@round/whitelabel-ui';
import styles from './DeleteProjectModal.module.css';
import { Button } from '@round/whitelabel-ui';
import cn from 'classnames';
import { ProjectsTableRow } from '../ProjectsTable/helpers';
import { useDeleteProjectMutation } from '@round/creatorbase-helpers/api-hooks';

type Props = {
    project: ProjectsTableRow | null;
    isOpen: boolean;
    onClose: () => void;
};

const DeleteProjectModal = ({ project, isOpen, onClose }: Props) => {
    const { deleteOne, isLoading } = useDeleteProjectMutation(project?.id);

    const handleDelete = async () => {
        if (!project) {
            return;
        }

        try {
            await deleteOne(project.id);
            showNotification('project deleted', 'info');
            onClose();
        } catch {
            showNotification('Could not delete project', 'error');
        }
    };

    return (
        <Modal className={styles.modal} closeOnOverlayClick isOpen={isOpen} onClose={onClose}>
            <Modal.Header>
                <Modal.Title>Delete project</Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles.body}>
                <p className={cn(styles.copy, styles.bold)}>You’re about to permanently delete the following:</p>
                <div className={styles.banner}>
                    <p className={styles.copy}>
                        <span className={styles.bold}>Project</span>:&nbsp;
                        {project && <>{project?.name}</>}
                    </p>
                    <p className={styles.copy}>
                        <span className={styles.bold}>Campaigns</span>:&nbsp;
                        {project && <>{project?.campaign_count}</>}
                    </p>
                    <p className={styles.copy}>
                        <span className={styles.bold}>Posts</span>:&nbsp;
                        {project && <>{project?.post_count}</>}
                    </p>
                </div>

                <p className={styles.copy}>
                    You cannot restore projects, campaigns, or posts. They are deleted permanently.
                </p>
            </Modal.Body>

            <Modal.Actions>
                <Button appearance="critical" isLoading={isLoading} onClick={handleDelete}>
                    Delete 1 project
                    {project && ` and ${project?.campaign_count + project?.post_count} associated entities`}
                </Button>
                <Button appearance="ghost" onClick={onClose}>
                    Cancel
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default DeleteProjectModal;
